const PLANNER_PLAN_PATH_PATTERN =
	/^\/jira\/software\/(?:c\/)?projects\/[A-Z][A-Z0-9_]*\/planner\/[A-Za-z0-9_-]+$/;

/**
 * Returns a Jira-relative Planner plan URL only when an embedded Planner
 * requests an absolute, same-origin destination matching a supported plan
 * route. The bridge payload is untrusted input, so all other destinations are
 * ignored by the host.
 */
export const getValidatedPlannerNavigationPath = (
	requestedUrl: string,
	currentOrigin: string,
): string | null => {
	let parsedUrl: URL;
	try {
		parsedUrl = new URL(requestedUrl);
	} catch {
		return null;
	}

	if (
		parsedUrl.origin !== currentOrigin ||
		parsedUrl.username !== '' ||
		parsedUrl.password !== '' ||
		!PLANNER_PLAN_PATH_PATTERN.test(parsedUrl.pathname)
	) {
		return null;
	}

	return `${parsedUrl.pathname}${parsedUrl.search}${parsedUrl.hash}`;
};
